<template>
	<row>
		<div class="col-xs-12">
			<slot />
		</div>
	</row>
</template>

<script>
export default {
	name: "BlockLine",
	components: {},
	props: [],
	data () {
		return {};
	},
	computed: {},
	watch: {},
	created () {
	},
	mounted () {
	},
	updated () {
	},
	destroyed () {
	},
	methods: {},
};
</script>

<style scoped>

</style>
